import { render } from "./HandleAgend.vue?vue&type=template&id=dd0e7d16&scoped=true"
import script from "./HandleAgend.vue?vue&type=script&lang=js"
export * from "./HandleAgend.vue?vue&type=script&lang=js"

import "./HandleAgend.vue?vue&type=style&index=0&id=dd0e7d16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd0e7d16"]])

export default __exports__